import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class ResultReportsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Result Reports',
            ROUTE_PATH.branchCategory,
            ROUTE_PATH.branchCategoryAdd,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Result Reports_' + new Date().toLocaleDateString() +'.xlsx', btnLabel: 'Download Result Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'CollegeName', value: 'name_of_college' }, { key: 'Branch', value: 'branch_name' }, { key: 'Batch', value: 'batch_number' }, { key: 'Sem1', value: 'semester1' }, { key: 'Sem2', value: 'semester2' }, { key: 'Sem3', value: 'semester3' }, { key: 'Sem4', value: 'semester4' }, { key: 'Sem5', value: 'semester5' }, { key: 'Sem6', value: 'semester6' }, { key: 'Sem7', value: 'semester7' }, { key: 'Sem8', value: 'semester8' }, { key: 'TotalPercent', value: 'scoreTotal' }, { key: 'Status', value: 'statusType' }] },
            false,
            null,
            false,
            false,
            true,
            null,
            { evalKey: 'statusType', evalParam: ['Alumni'], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            true,
            [{ label: '', colspan: '1', class: '' }, { label: '', colspan: '1', class: '' }, { label: '', colspan: '1', class: '' }, { label: 'Academic Score (Semester Wise)', colspan: '8', class: "text-center px-2" }, { label: '', colspan: '2', class: '' }, { label: '', colspan: '2', class: '' }],
            false,
            { isExtraActions: true, btnLabel: 'Notify Students' },
            {isCheckboxEmit: true, emitKey: 'id', checkedKey: '', valueKey: ''}
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const collegeName = new Headers('College Name', 'name_of_college', false, false, 'text');
        const branch = new Headers('Branch', 'branch_name', false, false, 'text');
        const semester1 = new Headers('Sem 1', 'semester1', false, false, 'text');
        const semester2 = new Headers('Sem 2', 'semester2', false, false, 'text');
        const semester3 = new Headers('Sem 3', 'semester3', false, false, 'text');
        const semester4 = new Headers('Sem 4', 'semester4', false, false, 'text');
        const semester5 = new Headers('Sem 5', 'semester5', false, false, 'text');
        const semester6 = new Headers('Sem 6', 'semester6', false, false, 'text');
        const semester7 = new Headers('Sem 7', 'semester7', false, false, 'text');
        const semester8 = new Headers('Sem 8', 'semester8', false, false, 'text');
        const overallKtStatus = new Headers('KT', 'isKT', false, false, 'text');
        // const scoreTotal = new Headers('Academic Total Score (%)', 'scoreTotal', false, false, 'text');
        const creditTotal = new Headers('Total (%)', 'scoreTotal', false, false, 'text');
        // const placement_company_name = new Headers('Company Name', 'placement_company_name', false, false, 'text');
        // const placement_company_designation = new Headers('Designation', 'placement_company_designation', false, false, 'text');
        // const placement_company_package = new Headers('CTC offered', 'placement_company_package', false, false, 'text');
        // const placement_company_location = new Headers('Company Location', 'placement_company_location', false, false, 'text');
        // const totalAssignmentAssigned = new Headers('Assignments Assigned', 'totalAssignmentAssigned', false, false, 'text');
        // const attended_Student = new Headers('Assignments Attended', 'attended_Student', false, false, 'text');
        // const notattended_Student = new Headers('Assignments Not Attended', 'notattended_Student', false, false, 'text');
        // const avgScore = new Headers('Average Score', 'avgScore', false, false, 'text');
        // const totalScoreInPercentage = new Headers('Assignment Total %', 'totalScoreInPercentage', false, false, 'text');
        const statusType = new Headers('Status', 'statusType', false, false, 'text');

        headers.push(studentName);
        headers.push(collegeName);
        headers.push(branch);
        headers.push(semester1);
        headers.push(semester2);
        headers.push(semester3);
        headers.push(semester4);
        headers.push(semester5);
        headers.push(semester6);
        headers.push(semester7);
        headers.push(semester8);
        headers.push(overallKtStatus);
        headers.push(creditTotal);
        // headers.push(placement_company_name);
        // headers.push(placement_company_designation);
        // headers.push(placement_company_package);
        // headers.push(placement_company_location);
        // headers.push(totalAssignmentAssigned);
        // headers.push(attended_Student);
        // headers.push(notattended_Student);
        // headers.push(avgScore);
        // headers.push(totalScoreInPercentage);
        headers.push(statusType);

        return headers;
    }
}